import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    menuItem: {
      '&:hover': {
        color: '#fff !important',
        '& span': {
          color: '#fff !important',
        },
      },
    },
    select__value: {
      color: theme.palette.primary.main,
    },
    select: {
      '& .MuiSelect-icon': {
        right: '0',
        top: '45%',
      },

      '& .MuiSelect-iconOpen': {
        top: 'calc(45% - 15px)',
        right: '13px',
      },
    },
  }),
);
